export default __webpack_public_path__ + "static/5i-5c9664b7e6f0c06501b64fbf80d17583.woff";